﻿<script setup>
import {defineModel} from 'vue';
import rules from "@/utils/validationRules.js";
import { useDisplay } from 'vuetify'
import ReferralFormLabel from "@/components/ReferralFormLabel.vue";

const { mdAndUp } = useDisplay();

const model = defineModel() 

function addNewCategory() {
    model.value.push({
      type: 'Improved Health and Wellbeing',
      amount: ''
    })
}

function removeCategory(index) {
  model.value.splice(index, 1)
}

</script>

<template>
  <v-row  class="py-0" align="center" justify="center">
    <template v-for="(category, index) in model">
      <v-col cols="12" md="6" class="py-0">
        <ReferralFormLabel required v-if="index === 0 || !mdAndUp">Funding Category</ReferralFormLabel>
        <v-select
            v-model="model[index].type"
            required
            :items="['Improved Health and Wellbeing', 'Improved Daily Living Skills', 'CORE']"
            :rules="[rules.required]"/>
      </v-col>
      <v-col cols="12" md="4" class="py-0">
        <ReferralFormLabel required v-if="index === 0 || !mdAndUp">Funding Amount</ReferralFormLabel>
        <v-text-field
            v-model="model[index].amount"
            required
            :rules="[rules.required, rules.fundingAmount]"
            type="number"
            pattern="[0-9]*" inputmode="numeric"
            prepend-inner-icon="mdi-currency-usd"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="2" class="py-0 d-flex justify-end justify-md-start mb-md-4">
        <v-btn icon="mdi-delete" v-if="index > 0 && mdAndUp" variant="text" color="grey" @click="removeCategory(index)" v-tooltip="'Remove Category'" :text="mdAndUp ? '' : 'Remove'"></v-btn>
        <v-btn v-if="index > 0 && !mdAndUp" variant="text" size="small" color="red" @click="removeCategory(index)">Remove Category</v-btn>
      </v-col>  
    </template>
    <v-col cols="12" class="pt-4 pt-md-0">
      <v-btn variant="tonal" color="blue" append-icon="$plus" @click="addNewCategory" :disabled="model.length > 2" :block="!mdAndUp"> Add another category </v-btn>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>
